module.exports = {
  siteKey: "6LdyU5ceAAAAAJlK0e5oNrTg-RYFGCiPpPpHl-yj",
};
